import { FC, Fragment } from 'react';
import { Divider } from 'antd';
import { ImagePreviewer } from '@base/lib/ImagePreviewer';
import { IReview } from 'mod/review/interface';
import { ReviewItemPC } from 'mod/review/ReviewItemPC';

export type IReviewListPCProps = {
    list: IReview[];
    className?: string;
    type?: 'simple' | 'whole';
    afterCount: number;
}

export const ReviewListPC: FC<IReviewListPCProps> = (props) => {
    const { list, className, afterCount } = props

    return list.length === 0 ? null : (
        <ImagePreviewer>
            {({ open }) => (
                <div className={className}  data-load-count={afterCount}>
                    {list.map((review, index) => (
                        <Fragment key={index}>
                            <ReviewItemPC
                                key={review.id}
                                review={review}
                                open={open}
                            />
                            <Divider/>
                        </Fragment>
                    ))}
                </div>
            )}
        </ImagePreviewer>
    )
}